<div class="group-header h3-regular" *ngIf="!noData">
    <tam-middle-ellipsis [text]='name'></tam-middle-ellipsis>
</div>
<div class="group-body" *ngIf="!noData&&!error">
    <tam-intralinks-folder [files]="files" [loading]="reloading" [autoHeight]=true
        [isgroup]="true"></tam-intralinks-folder>
</div>
<div class="group-body" *ngIf="!noData&&error">
    {{error}}
</div>